module.exports = __webpack_public_path__ + "static/media/vip-access.121003c1.svg";